import { defineStore } from "pinia";

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    message: null,
    type: "error", // 'success', 'error', 'warning', 'info'
    isVisible: false,
    duration: 5000, // 5秒後に自動的に閉じる
  }),

  actions: {
    showNotification(message, type = "error", duration = 5000) {
      this.message = message;
      this.type = type;
      this.duration = duration;
      this.isVisible = true;

      // 自動的に閉じる
      if (duration > 0) {
        setTimeout(() => {
          this.hideNotification();
        }, duration);
      }
    },

    showError(message, duration = 5000) {
      this.showNotification(message, "error", duration);
    },

    showSuccess(message, duration = 3000) {
      this.showNotification(message, "success", duration);
    },

    showWarning(message, duration = 4000) {
      this.showNotification(message, "warning", duration);
    },

    showInfo(message, duration = 3000) {
      this.showNotification(message, "info", duration);
    },

    hideNotification() {
      this.isVisible = false;
      // フェードアウトアニメーション後にメッセージをクリア
      setTimeout(() => {
        this.message = null;
      }, 300);
    },
  },
});
